import PageTitle from 'src/components/PageTitle';
import { RoutableTabsLayout } from 'src/router';
import { routes } from './routes';

function AdminDashboard() {
  return (
    <>
      <PageTitle />
      <RoutableTabsLayout
        routes={routes}
        overview={undefined}
        refreshData={undefined}
      />
    </>
  );
}

export default AdminDashboard;
